var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHabits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "habits",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21289 16H8.26367V9.92969C8.26367 9.69922 8.26367 9.50195 8.26367 9.33789C8.26758 9.16992 8.27148 9.01758 8.27539 8.88086C8.2832 8.74023 8.29297 8.59766 8.30469 8.45312C8.18359 8.57812 8.07031 8.68555 7.96484 8.77539C7.85938 8.86133 7.72852 8.96875 7.57227 9.09766L6.59375 9.88281L6.08398 9.2207L8.4043 7.43359H9.21289V16ZM15.166 10.7617C15.748 10.7617 16.2539 10.8613 16.6836 11.0605C17.1133 11.2559 17.4453 11.541 17.6797 11.916C17.918 12.291 18.0371 12.7461 18.0371 13.2812C18.0371 13.8672 17.9102 14.373 17.6562 14.7988C17.4023 15.2207 17.0371 15.5469 16.5605 15.7773C16.084 16.0039 15.5137 16.1172 14.8496 16.1172C14.4043 16.1172 13.9902 16.0781 13.6074 16C13.2246 15.9219 12.9023 15.8047 12.6406 15.6484V14.7227C12.9258 14.8945 13.2715 15.0312 13.6777 15.1328C14.084 15.2344 14.4785 15.2852 14.8613 15.2852C15.2949 15.2852 15.6738 15.2168 15.998 15.0801C16.3262 14.9395 16.5801 14.7285 16.7598 14.4473C16.9434 14.1621 17.0352 13.8047 17.0352 13.375C17.0352 12.8047 16.8594 12.3652 16.5078 12.0566C16.1602 11.7441 15.6094 11.5879 14.8555 11.5879C14.6133 11.5879 14.3477 11.6074 14.0586 11.6465C13.7695 11.6855 13.5312 11.7285 13.3438 11.7754L12.8516 11.4531L13.1797 7.43359H17.4395V8.32422H14.0117L13.7949 10.9082C13.9434 10.877 14.1348 10.8457 14.3691 10.8145C14.6035 10.7793 14.8691 10.7617 15.166 10.7617Z",
    fill: "black",
    stroke: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "black",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHabits);
export default __webpack_public_path__ + "static/media/habits.2177fdf6738d7e240b93888ec38162a3.svg";
export { ForwardRef as ReactComponent };